import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrashAlt, faLock, faLockOpen, faPlus, faBan, faFileAlt, faRedoAlt, faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import { useHistory } from 'react-router';
import Busca from './Busca';
import { actions as actionSite } from './../../../../redux/actions/site';
import { useDispatch } from 'react-redux';
import './Listagem.scss';

const Listagem = props => {

    const history = useHistory();
    const dispatch = useDispatch();

    const [page, setPage] = useState(0);
    const [paramsSearch, setParamsSearch] = useState([]);
    const total = props.registros.total;

    const setAcao = (acao, id) => {
        let rota = `/painel/${props.rota}/${acao}`;
        if (id) {
            rota += `/${id}`;
        }
        history.push(rota);
    };

    const openModalCancelar = (obj) => {
        let txt;

        if(props.compra)  {
            txt = `Cancelar o pedido vai debitar do estoque. Deseja continuar?`;
        } else {
            if(obj.processado){
                txt = `Cancelar um pedido já processado vai creditar no estoque. Deseja continuar?`;
            } else {
                txt = `Deseja continuar?`;
            }
        }
        const configModal = {
            msg: txt, title: "Cancelar Pedido",
            actions: [
                { label: "Sim", class: "azul", callback: cancelar, arg: obj },
            ]
        }

        dispatch(actionSite.setModal(configModal))
    }

    const cancelar = async (obj) => {
        dispatch(actionSite.setModal(null));
        dispatch(actionSite.setLoadingMsg("Cancelando pedido..."))
        const res = await props.service.cancelar(obj._id);
        dispatch(actionSite.setLoadingMsg(res.msg));
        setTimeout(() => {
            dispatch(actionSite.setLoadingMsg(""));
            if (!res.erro) {
                props.service.getList([], 0);
            }
        }, 2000);
    }

    const getSituacao = pedido => {
        if (!pedido.cancelado && pedido.processado && pedido.entregue) return "Entregue";
        if (!pedido.cancelado && !pedido.entregue && !pedido.processado) return "Pendente";
        if (pedido.processado && !pedido.cancelado) return "Processado";
        if (pedido.cancelado) return "Cancelado";
    }

    const podeCancelar = pedido => {
        return !pedido.cancelado && !pedido.processado && !pedido.entregue;
    }

    const podeEditar = pedido => {
        return !pedido.cancelado && !pedido.processado && !pedido.entregue;
    }


    const renderItems = () => {
        if (props.loadingList) {
            return (
                <tr>
                    <td colSpan={props.config.columns.length + 2}>Carregando listagem...</td>
                </tr>
            );
        }
        if (props.registros.rows.length > 0) {
            return props.registros.rows.map((ele, index) => {
                return (
                    <tr key={index} id={ele._id}>
                        {renderColumnsItems(ele)}
                        <td>{getSituacao(ele)}</td>
                        <td className="acoes">

                            {podeEditar(ele) &&
                                <button className="edit" onClick={() => { setAcao('form', ele._id) }}><FontAwesomeIcon icon={faEdit} /></button>
                            }
                           
                            {podeCancelar(ele) &&
                                <button className="delete" onClick={() => { openModalCancelar(ele) }}><FontAwesomeIcon icon={faBan} /></button>
                            }
                        </td>
                    </tr>
                )
            })
        } else {
            return (
                <tr>
                    <td colSpan={props.config.columns.length + 2}>Nenhum registro encontrado</td>
                </tr>
            )
        }
    };

    const renderTitles = () => {
        const thead = (
            <tr>
                {/* { props.config.sort === 'ordem' && <td>#</td> } */}
                {renderColumns()}
                <td>Situação</td>
                <td width="200">Ações</td>
            </tr>
        );
        return thead;
    }

    const renderColumns = () => {
        return props.config.columns.map((c, i) => {
            return (
                <td key={i}>{c.label}</td>
            );
        });
    }

    const converts = {
        toImg: s => {
            return <img src={s} className="imgCrud" alt="imagem" />
        },
        toSimNao: s => {
            return s ? "Sim" : "Não";
        }
    }

    const renderColumnsItems = (row) => {
        return props.config.columns.map((c, i) => {
            const cls = c.field === "ordem" ? 'order' : '';
            return (
                <React.Fragment key={i}>
                    <td className={cls} width={c.width || ""}>
                        {renderValue(row, c)}
                    </td>
                </React.Fragment>
            );
        });
    }

    const renderValue = (row, c) => {
        try {

            let value = row[c.field];

            if (c.field.includes('.') && row) {
                value = eval(`row.${c.field}`) || null;
            }

            if (c.filter) {
                const filtrado = row[c.filter.field].find(e => e[c.filter.condition.field] === c.filter.condition.value);
                if (filtrado) {
                    value = filtrado[c.field];
                }
            }

            if (c.convert) {
                if (typeof c.convert === 'string') {
                    return converts[c.convert](value);
                } else if (typeof c.convert === 'function') {
                    return c.convert(value);
                }
            }

            return value;
        } catch (e) {

        }
    }

    const buscar = params => {
        props.service.getList(params, 0);
        setParamsSearch(params);
        setPage(0);
    }

    const getList = _ => {
        props.service.getList([], 0);
        setPage(0);
    }

    const proximo = () => {
        const skip = page + props.config.pagination.limit;
        if (skip < total) {
            props.service.getList(paramsSearch, skip);
            setPage(skip)
        }
    }

    const temProximo = () => {
        const skip = page + props.config.pagination.limit;
        return skip < total;
    }
    const temAnterior = () => {
        const skip = page - props.config.pagination.limit;
        return skip >= 0;
    }

    const anterior = () => {
        const skip = page - props.config.pagination.limit;
        if (skip >= 0) {
            props.service.getList(paramsSearch, skip);
            setPage(skip)
        }
    }

    const getNumeroUltimoItem = () => {
        let n = ((page) + props.config.pagination.limit);
        if (n > total) {
            n = total;
        }
        return n;
    }

    return (
        <>
            <div className="crudView">
                <div className="searchBox">
                    <Busca config={props.config} service={{ buscar, getList }} />
                    <button onClick={() => { setAcao('form') }} className="novo"><FontAwesomeIcon icon={faPlus} /> Novo Registro</button>
                </div>
                <div className="gridView">
                    <div className="pagination">
                        <span>{page + 1}-{getNumeroUltimoItem()} de {props.registros.total}</span>
                        <div className="links">
                            <span onClick={() => anterior()} className={!temAnterior() ? "disable" : ""}>anterior</span>
                            <span onClick={() => proximo()} className={!temProximo() ? "disable" : ""}>próximo</span>
                        </div>
                    </div>
                    <table cellPadding="0" cellSpacing="0">
                        <thead>
                            {renderTitles()}
                        </thead>
                        <tbody>
                            {renderItems()}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}

export default Listagem;